import { Button, Card, ConfigProvider, Form, message, Modal, notification, Steps } from 'antd';
import  { useContext, useEffect, useState } from 'react'
import GlobalContext from "../../../../context/GlobalContext"
import { useTranslation } from 'react-i18next';
import { useLoader } from '../../../../context/LoaderContext';
import { addCalendrierExamenRattrapage, decalageCalendrierSession, getDetailsExamenRattrapage } from '../../../../api/geoprod';
import GestionCalendrierExamensCarte from './GestionCalendrierExamensCarte';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
const GestionCalendrierExamensRattrapages = () => {
  const {currentStep, setCurrentStep ,globalData, setGlobalData,dates, setDates,modulesExamens, setModulesExamens,modulesRattrapages, setModulesRattrapages } = useContext(GlobalContext);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [confirmVisible, setConfirmVisible] = useState(false);
const [scheduledExam, setScheduledExam] = useState(
  JSON.parse(sessionStorage.getItem("globalData"))?.scheduledExam || []
);



const [scheduledRattrapage, setScheduledRattrapage] = useState(
  JSON.parse(sessionStorage.getItem("globalData"))?.scheduledRattrapage || []
);

const [showCalendarExam, setShowCalendarExam] = useState(JSON.parse(sessionStorage.getItem("globalData"))?.showCalendarExam || false)
const [showCalendarRattrapage, setShowCalendarRattrapage] = useState(JSON.parse(sessionStorage.getItem("globalData"))?.showCalendarRattrapage || false)
  const navigate = useNavigate();
const datesSession = JSON.parse(sessionStorage.getItem("globalData"))?.datesSession 
  const params = useLocation();
  const id_calendrier_examen = params?.state?.id_calendrier_examen
  const id_affaire  = params?.state?.id_affaire
  const id_calendrier_rattrapage = params?.state?.id_calendrier_rattrapage
  useEffect(() => {
 console.log("id_calendrier_rattrapage",id_calendrier_examen,id_calendrier_rattrapage)
}, [])
  const { setIsLoading } = useLoader();
    const steps = [
        {
          title: (
            <>
              <div>Calendrier examens</div>
              <div style={{ fontSize: 12, color: 'gray' }}>Calendrier examens</div>
            </>
          ),
            content:  <GestionCalendrierExamensCarte form={form} modules={modulesExamens} setModules={setModulesExamens} title={"Calendrier des examens"} dateDebut={"23/05/2025"} dateFin={"28/05/2025"} type="examen" scheduled={scheduledExam} setScheduled={setScheduledExam} showCalendar={showCalendarExam} setShowCalendar={setShowCalendarExam} dates={dates} setDates={setDates} id_calendrier={id_calendrier_examen} id_affaire={id_affaire}/>,
        },
        id_calendrier_rattrapage && {
          title: (
            <>
              <div>Calendrier rattrapage</div>
              <div style={{ fontSize: 12, color: 'gray' }}>Calendrier rattrapage</div>
            </>
          ),
            content: <GestionCalendrierExamensCarte form={form} modules={modulesRattrapages} setModules={setModulesRattrapages} title={"Calendrier des rattrapage"} dateDebut={"01/05/2026"} dateFin={"09/05/2026"} type="rattrapage" scheduled={scheduledRattrapage} setScheduled={setScheduledRattrapage} showCalendar={showCalendarRattrapage} setShowCalendar={setShowCalendarRattrapage} dates={dates} setDates={setDates} id_calendrier={id_calendrier_rattrapage} id_affaire={id_affaire}/> ,
        }
      ].filter(Boolean);
      const items = steps?.map((item, index) => ({
        key: index?.toString(),
        title: item?.title,
      }));
      
      const prevStep = () => {
        if (currentStep > 0) {
          setCurrentStep(currentStep - 1);
          sessionStorage.setItem("currentStep", (currentStep - 1).toString());
        }
      };
    
      const saveSession = () => {
       const existingData = JSON?.parse(sessionStorage?.getItem("globalData")) 
        const newData = {
        modulesExamens,
        modulesRattrapages,
        dates,
        scheduledExam,
        scheduledRattrapage,
        showCalendarExam,
        showCalendarRattrapage
      };
      const mergedData = {
    ...existingData,
    ...globalData,
    ...newData
  };
      sessionStorage.setItem("globalData", JSON.stringify(mergedData));
        setGlobalData(mergedData);
        sessionStorage.setItem("currentStep", currentStep.toString());
      }
      const nextStep = async () => {
        if(currentStep === 0 && modulesExamens.length > 0)
        {
          notification.error({
              message: t("Erreur"),
              description: t(
                "Veuillez planifier tous les modules avant de passer à l’étape suivante"
              ),
              duration: 0,
            });
        }
         else if (currentStep < steps.length - 1) {
          sessionStorage.setItem("currentStep", currentStep + 1); 
          setCurrentStep(currentStep + 1);
          saveSession();
        }
        else
          {
            if(modulesRattrapages?.length > 0)
            {
            notification.error({
                  message: t("Erreur"),
                  description: t(
                    "Veuillez planifier tous les modules de rattarpage avant de passer à l’étape suivante"
                  ),
                  duration: 0,
                });
            }
            else 
            {
              setConfirmVisible(true);
            }

          }
      };

 

function isDatesChanged(dates_initial, datesFinal) {
  const keysToCompare = ['examen', 'rattrapage'];

  for (const key of keysToCompare) {
    const initial = dates_initial.dates[key];
    const final = datesFinal.datesSession[key];

    if (
      initial.startDate !== final.startDate ||
      initial.endDate !== final.endDate
    ) {
      return true;
    }
  }

  return false;
}


const handleFinalConfirm = async () => 
    {
    setIsLoading(true)
    const periode = JSON?.parse(sessionStorage?.getItem("globalData"))?.periode || ""
    const mapData = (data, type) => {
      return Object.entries(data).flatMap(([date, sessions]) =>
        sessions?.map((session) => ({
          id_module: session?.id_md,
          date_deb: dayjs(date,"DD/MM/YYYY").format("YYYY-MM-DD"),
          date_fin:  dayjs(date,"DD/MM/YYYY").format("YYYY-MM-DD"),
          heure_deb: session?.start,
          heure_fin: session?.end,
          salle: session?.room,
          type,
          periode:periode,
        }))
      );
    };
    const finalData = [
      ...mapData(scheduledExam, "examen"),
      ...mapData(scheduledRattrapage, "rattrapage"),
    ];
    const payload = 
    {
      "id_affaire":id_affaire,
      "modules":finalData
    }
    addCalendrierExamenRattrapage(payload)
    .then( (responseAddCalendrier) => {


          const payloadDecalageExamen = {
            "calendrier" :
            [
              {   "id_affaire": id_affaire,
                  "id_calendrier":id_calendrier_examen,
                  "date_debut": dayjs(dates?.examen?.startDate,"DD/MM/YYYY").format("YYYY-MM-DD"),
                  "date_fin":dayjs(dates?.examen?.endDate,"DD/MM/YYYY").format("YYYY-MM-DD"),
              }, 
              {   "id_affaire": id_affaire,
                  "id_calendrier":id_calendrier_examen,
                  "date_debut": dayjs(dates?.examen?.startDate,"DD/MM/YYYY").format("YYYY-MM-DD"),
                  "date_fin":dayjs(dates?.examen?.endDate,"DD/MM/YYYY").format("YYYY-MM-DD"),
              }

            ]
          }
 decalageCalendrierSession(payloadDecalageExamen)
.then( (response) => {

  navigate("/sessionFormationHomologuee/getAllExams",
                          {
                              state: {
                                id_affaire: id_affaire
                              },
                            }
                        );
     notification.success({
        description: t(
          responseAddCalendrier?.data?.message
        ),
        duration: 0,
      });
      setIsLoading(false)
    })
    .catch((error)=>{
       notification?.error({
                  message: t("Erreur"),
                  description:  t(error?.data?.message),
                  duration: 0,
                });
      setIsLoading(false)
      
    })
  // }
  // else 
  // {
  //    navigate("/sessionFormationHomologuee/getAllExams");
  //    notification.success({
  //       description: t(
  //         responseAddCalendrier?.data?.message
  //       ),
  //       duration: 0,
  //     });
  //     setIsLoading(false)
  // }
    })
    .catch((error)=>{
       notification?.error({
                  message: t("Erreur"),
                  description: t(error?.data?.message),
                  duration: 0,
                });
      setIsLoading(false)
      
    })
    setConfirmVisible(false);
  };

 

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#195A99",
          lineWidth: 1,
          fontFamily: "open sans, Helvetica, Arial, sans-serif"
        },
        components: {
          DatePicker: { colorBorder: "#195A99", colorPrimaryHover: "#195A99" },
          Radio: { colorPrimary: "#195A99" },
          Input: {
            lineWidth: 2,
            colorBorder: "#195A99",
            colorPrimaryHover: "#195A99",
            colorPrimary: "#195A99",
            controlHeight: 45,
            fontSize: 14,
            colorText: "#000",
          },
          Select: {
            // lineWidth: 2,
            fontSize: 13,
            colorPrimaryHover: "#195A99",
          },

       
        },
      }}
    >
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Saisie calendrier des examens et des rattrapage</span>
        </div>
      }
      bordered={false}
      style={{
        margin: "auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
       {/* <Spin spinning={isLoading} tip="" style={{ width: "100%" }}> */}
        <Form
        
          noValidate
          form={form}
          layout="vertical"
          // onFinish={nextStep}
          // onFinishFailed={() => {
          //   notification.error({
          //     message: t("Erreur"),
          //     description: t("Veuillez remplir tous les champs obligatoires."),
          //     duration: 0,
          //   });
          // }}
          onKeyDown={(e) => (e.key === "Enter" ? e.preventDefault() : null)}
        >
          <Steps current={currentStep} items={items}  progressDot  className="stepper" 
          />
          <div  style={{margin: "2rem"}}>
            {steps[currentStep]?.content}
          </div>
          <div style={{ marginTop: "20px" , display:"flex", justifyContent:"space-between"}}>
              <Button
                onClick={prevStep}
                style={{ marginInline: "1rem" }}
                disabled={currentStep <= 0}
              >
                {t('Précédent')} 
              </Button>
            <Button type="primary" 
                        onClick={() => nextStep()}
                        
            // htmlType="submit" 
            >suivant
            {/* {currentStep < steps.length - 1 ? t('Suivant') : t('Valider')} */}
          </Button>
          </div>
        </Form>
      {/* </Spin> */}
      <Modal 
  title="Confirmer le calendrier"
  open={confirmVisible}
  onCancel={() => setConfirmVisible(false)}
  onOk={handleFinalConfirm}
  okText="Confirmer"
  cancelText="Annuler"
  width={800}
>
  <h3 style={{ color: "#1890ff", marginBottom: 12, fontWeight: "bold" }}>📘 Examens</h3>
  {Object.keys(scheduledExam).sort().map((dateKey) => (
    <Card
      key={dateKey}
      title={
        <span style={{ fontWeight: "bold", color: "#1890ff" }}>
          {dayjs(dateKey, "DD/MM/YYYY").format("dddd DD/MM/YYYY").replace(/^./, (c) => c.toUpperCase())}
        </span>
      }
      size="small"
      style={{ marginBottom: 16, backgroundColor: "#f0f5ff", border: "1px solid #adc6ff" }}
    >
      {(scheduledExam[dateKey] || []).map((mod) => (
        <div
          key={mod.id + mod.start}
          style={{  padding: 8, backgroundColor: "#ffffff", borderRadius: 6 }}
        >
          <strong>{mod.id}</strong> ({mod.name}) – {mod.start} à {mod.end} – Salle: {mod.room}
        </div>
      ))}
    </Card>
  ))}

  {Object.keys(scheduledRattrapage).length > 0 && (
    <>
      <h3 style={{ color: "#fa8c16", marginTop: 24, marginBottom: 12, fontWeight: "bold" }}>📙 Rattrapages</h3>
      {Object.keys(scheduledRattrapage).sort().map((dateKey) => (
        <Card
          key={dateKey}
          
          title={
            <span style={{ fontWeight: "bold", color: "#fa8c16" }}>
            {dayjs(dateKey, "DD/MM/YYYY").format("dddd DD/MM/YYYY").replace(/^./, (c) => c.toUpperCase())}
            </span>
          }
          border={false}
          size="small"
          style={{ marginBottom: 16, backgroundColor: "#fff7e6", border: "1px solid #ffd591" }}
        >
          {(scheduledRattrapage[dateKey] || []).map((mod) => (
            <div
              key={mod.id + mod.start}
              style={{ padding: 8, backgroundColor: "#ffffff", borderRadius: 6 }}
            >
              <strong>{mod.id}</strong> ({mod.name}) – {mod.start} à {mod.end} – Salle: {mod.room}
            </div>
          ))}
        </Card>
      ))}
    </>
  )}
</Modal>
      </Card>
    </ConfigProvider>
  )
}

export default GestionCalendrierExamensRattrapages;